import { Check } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { IMG } from "../config";

const POINTS = [
  "Lahir, tumbuh, dan belajar di Cianjay",
  "Balai desa terbuka tanpa sekat protokol",
  "Mendengar dengan empati, bertindak dengan nyata",
];

export const Profil = () => (
  <section id="profil" data-testid="profil-section" className="py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 grid lg:grid-cols-12 gap-14 items-center">
      <div className="lg:col-span-6 order-2 lg:order-1">
        <SectionHeading
          bab="Bab 02"
          label="Profil Singkat"
          title="Balai Desa adalah Rumah Kita Bersama"
          testid="profil"
        />
        <Reveal delay={0.25}>
          <p className="mt-7 text-base leading-relaxed text-ink/85">
            Bagi saya, jabatan Kepala Desa bukanlah tentang kekuasaan, melainkan{" "}
            <span className="font-semibold text-terra">mandat penuh untuk melayani</span>. Saya lahir,
            tumbuh, dan belajar di Cianjay. Melihat anak-anak kita tersenyum, pemuda kita bebas berkreasi,
            dan para orang tua kita hidup tenang adalah alasan saya bangun setiap pagi.
          </p>
          <p className="mt-5 text-base leading-relaxed text-ink/85">
            Cianjay bukan sekadar titik di peta Kecamatan Cianjir; Cianjay adalah denyut nadi kita semua.
            Mari wujudkan desa yang inklusif, sejahtera, dan merangkul semua kalangan tanpa terkecuali.
          </p>
        </Reveal>
        <Reveal delay={0.35}>
          <ul className="mt-8 space-y-3.5">
            {POINTS.map((p, i) => (
              <li key={i} className="flex items-start gap-3" data-testid={`profil-point-${i}`}>
                <span className="mt-0.5 grid place-items-center w-6 h-6 rounded-full bg-forest text-bg shrink-0">
                  <Check size={13} strokeWidth={3} />
                </span>
                <span className="text-sm sm:text-base font-medium text-ink/85">{p}</span>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.45}>
          <p className="mt-10 font-serif italic text-xl text-forest">— Mulyono M.H.</p>
        </Reveal>
      </div>

      <div className="lg:col-span-6 order-1 lg:order-2">
        <Reveal delay={0.15} y={50}>
          <div className="relative">
            <div className="absolute -inset-3 rounded-[2rem] border border-gold/60 rotate-2" />
            <div className="relative overflow-hidden rounded-[2rem] shadow-[0_30px_60px_rgba(30,58,43,0.18)]">
              <img
                src={IMG.bantuan}
                alt="Pak Kades menyalami warga lansia saat penyaluran bantuan desa"
                data-testid="profil-photo"
                className="w-full aspect-[4/3] object-cover transition-transform duration-700 hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-6 left-6 right-6 sm:right-auto rounded-2xl bg-forest text-bg px-6 py-4 shadow-xl">
              <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-gold">Mandat Melayani</p>
              <p className="font-serif text-lg mt-1">"Dari warga, oleh warga, untuk Cianjay."</p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
